module.exports = __webpack_public_path__ + "static/assets/80273036af50141f12d92825bda428cb.png";